import { styles as commonStyles } from '../../../assets/common.scss';
import { styles } from './template.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { ImageState } from '../../../ui/gzImageRepo/types';

const easmArtifactsInventoryGridTemplate = document.createElement('template');

easmArtifactsInventoryGridTemplate.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <header class='page__header'>
    <gz-title id="title" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.TITLE}" />
  </header>

  <gz-image-repo id="no-eligible-targets" state="${ImageState.EMPTY}" class="hidden">
    <gz-title id="no-eligible-targets-message" fontweight="500" fontsize="20"></gz-title>
  </gz-image-repo>

  <gz-push-body-layout resizable="right" class="hidden">
    <div slot="push-body-sidenav-title">
      <gz-title id="smart-views-title" fontsize="11" fontweight="600" />
    </div>

    <div slot="push-body-sidenav">
      <gz-generic-grid-smart-views class="hidden" />

      <div class="smart-views-loader">
        <gz-loader rows="4" />
      </div>
    </div>

    <div class="push-body" slot="push-body-content">
      <div class="push-body--content">
        <div class="wrapper">
          <div class="content">
            <div class="grid">
              <gz-grid-view hasSelectableRows noEscapeSpaceInTitle showGlobalActions>
                <div class="header-buttons" slot="grid-header-actions-slot">
                  <gz-button id="scan-configuration-button" class="mr-2" type="full"></gz-button>

                  <gz-select-menu-with-button
                    id="change-investigation-status-button"
                    class="mr-2"
                    buttonColor="secondary"
                    buttonType="quiet"
                    disabled
                  >
                  </gz-select-menu-with-button>
                  <gz-select-menu-with-button
                    id="assign-button"
                    class="mr-2"
                    buttonColor="secondary"
                    buttonType="quiet"
                    disabled
                  >
                  </gz-select-menu-with-button>
                  <gz-select-menu-with-button
                    id="prioritize-button"
                    class="mr-2"
                    buttonColor="secondary"
                    buttonType="quiet"
                    disabled
                  >
                  </gz-select-menu-with-button>
                </div>

                <div slot="no-results--additional-data">
                  <gz-text id="no-results-additional-message" fontSize="14" />
                </div>
              </gz-grid-view>
            </div>
          </div>
        </div>
      </div>

      <gz-easm-side-menu
        class="push-body-sidenav resize-content"
        resizable="left"
        menuwidth="400"
        closeOnClickOutside
      />
    </div>
  </gz-push-body-layout>
`;

export default easmArtifactsInventoryGridTemplate;
